/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Confirmation_Autonomous_HintInputs */



/**
* | output |
* | --- |
* | "Does not ask. Actions outside oneAI still wait for approval unless your organization allows them. Actions that cannot be undone, like deleting data, wait unl..." |
*
* @param {Agent_Builder_Confirmation_Autonomous_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_confirmation_autonomous_hint = /** @type {((inputs?: Agent_Builder_Confirmation_Autonomous_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Confirmation_Autonomous_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fragt nicht nach. Aktionen außerhalb von oneAI warten trotzdem auf Freigabe, sofern Ihre Organisation das nicht erlaubt. Aktionen, die sich nicht rückgängig machen lassen, etwa Daten löschen, warten, sofern Ihre Organisation und dieser Agent das nicht erlauben.")
	return /** @type {LocalizedString} */ ("Does not ask. Actions outside oneAI still wait for approval unless your organization allows them. Actions that cannot be undone, like deleting data, wait unless your organization and this agent allow them.")
});